import { MapContainer, TileLayer, Marker, Popup, useMap, LayersControl } from 'react-leaflet';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPointMap } from "../../redux/actions/mapActions";
import React from 'react';
import L from 'leaflet';

const { BaseLayer } = LayersControl

function LegendWithImage() {
  const map = useMap();

  React.useEffect(() => {
    const legend = L.control({ position: "bottomright" });

    legend.onAdd = () => {
      const div = L.DomUtil.create("div", "info legend");
      div.innerHTML = `
        <h4>Leyenda</h4>
        <img src="assets/img/pointsMap/leyenda.png" alt="Leyenda" style="width:200px; border:1px solid #ccc; border-radius:5px;" />
      `;
      return div;
    };

    legend.addTo(map);

    return () => {
      map.removeControl(legend);
    };
  }, [map]);

  return null;
}

export function MapEarthquake() {
  const dispatch = useDispatch();
  const points = useSelector(state => state.map.points);

  useEffect(() => {
    if (!points || points.length === 0) {
      const guardados = localStorage.getItem("puntosMapa");
      if (guardados) {
        dispatch(setPointMap(JSON.parse(guardados)));
      }
    }
  }, [points, dispatch]);

const getCustomIcon = (mag, prof) => {
  
  let iconUrl = "";
  let iconSize = [11, 11];
  const profundidad = Math.abs(prof);
  const magnitud = Math.abs(mag);

  // Punto Rojo
  if ((profundidad >= 0 && profundidad < 30) && (magnitud >= 0 && magnitud < 3.0)) {
    iconUrl = "assets/img/pointsMap/puntorojo.gif";
    iconSize = [6, 6]; 
  } 
  else if ((profundidad >= 0 && profundidad < 30) && (magnitud >= 3.0 && magnitud < 4.0)) {
    iconUrl = "assets/img/pointsMap/puntorojo2.gif";
    iconSize = [9, 9]; 
  } 
  else if ((profundidad >= 0 && profundidad < 30) && (magnitud >= 4.0 && magnitud < 5.0)) {
    iconUrl = "assets/img/pointsMap/puntorojo3.gif";
    iconSize = [11, 11]; 
  } 
  else if ((profundidad >= 0 && profundidad < 30) && (magnitud >= 5.0 && magnitud < 6.0)) {
    iconUrl = "assets/img/pointsMap/puntorojo4.gif";
    iconSize = [15, 15]; 
  } else if ((profundidad >= 0 && profundidad < 30) && (magnitud >= 6.0 && magnitud <= 9.0)) {
    iconUrl = "assets/img/pointsMap/puntorojo5.gif";
    iconSize = [26, 26]; 
  } else if ((profundidad >= 30 && profundidad < 70) && (magnitud >= 0 && magnitud < 3.0)) { //amarillo
    iconUrl = "assets/img/pointsMap/puntoamarillo.gif";
    iconSize = [6, 6]; 
  } 
  else if ((profundidad >= 30 && profundidad < 70) && (magnitud >= 3.0 && magnitud < 4.0)) {
    iconUrl = "assets/img/pointsMap/puntoamarillo2.gif";
    iconSize = [9, 9]; 
  } 
  else if ((profundidad >= 30 && profundidad < 70) && (magnitud >= 4.0 && magnitud < 5.0)) {
    iconUrl = "assets/img/pointsMap/puntoamarillo3.gif";
    iconSize = [11, 11]; 
  } 
  else if ((profundidad >= 30 && profundidad < 70) && (magnitud >= 5.0 && magnitud < 6.0)) {
    iconUrl = "assets/img/pointsMap/puntoamarillo4.gif";
    iconSize = [15, 15]; 
  } else if ((profundidad >= 30 && profundidad < 70) && (magnitud >= 6.0 && magnitud <= 9.0)) {
    iconUrl = "assets/img/pointsMap/puntoamarillo5.gif";
    iconSize = [26, 26]; 
  } else if ((profundidad >= 70 && profundidad < 120) && (magnitud >= 0 && magnitud < 3.0)) { //verde
    iconUrl = "assets/img/pointsMap/puntoverde.gif";
    iconSize = [6, 6]; 
  } 
  else if ((profundidad >= 70 && profundidad < 120) && (magnitud >= 3.0 && magnitud < 4.0)) {
    iconUrl = "assets/img/pointsMap/puntoverde2.gif";
    iconSize = [9, 9]; 
  } 
  else if ((profundidad >= 70 && profundidad < 120) && (magnitud >= 4.0 && magnitud < 5.0)) {
    iconUrl = "assets/img/pointsMap/puntoverde3.gif";
    iconSize = [11, 11]; 
  } 
  else if ((profundidad >= 70 && profundidad < 120) && (magnitud >= 5.0 && magnitud < 6.0)) {
    iconUrl = "assets/img/pointsMap/puntoverde4.gif";
    iconSize = [15, 15]; 
  } else if ((profundidad >= 70 && profundidad < 120) && (magnitud >= 6.0 && magnitud <= 9.0)) {
    iconUrl = "assets/img/pointsMap/puntoverde5.gif";
    iconSize = [26, 26]; 
  } else if ((profundidad >= 120 && profundidad < 180) && (magnitud >= 0 && magnitud < 3.0)) { //azul
    iconUrl = "assets/img/pointsMap/puntoazul.gif";
    iconSize = [6, 6]; 
  } 
  else if ((profundidad >= 120 && profundidad < 180) && (magnitud >= 3.0 && magnitud < 4.0)) {
    iconUrl = "assets/img/pointsMap/puntoazul2.gif";
    iconSize = [9, 9]; 
  } 
  else if ((profundidad >= 120 && profundidad < 180) && (magnitud >= 4.0 && magnitud < 5.0)) {
    iconUrl = "assets/img/pointsMap/puntoazul3.gif";
    iconSize = [11, 11]; 
  } 
  else if ((profundidad >= 120 && profundidad < 180) && (magnitud >= 5.0 && magnitud < 6.0)) {
    iconUrl = "assets/img/pointsMap/puntoazul4.gif";
    iconSize = [15, 15]; 
  } else if ((profundidad >= 120 && profundidad < 180) && (magnitud >= 6.0 && magnitud <= 9.0)) {
    iconUrl = "assets/img/pointsMap/puntoazul5.gif";
    iconSize = [26, 26]; 
  }else if ((profundidad >= 180) && (magnitud >= 0 && magnitud < 3.0)) {
    iconUrl = "assets/img/pointsMap/puntomorado.gif";
    iconSize = [6, 6]; 
  } 
  else if ((profundidad >= 180) && (magnitud >= 3.0 && magnitud < 4.0)) {
    iconUrl = "assets/img/pointsMap/puntomorado2.gif";
    iconSize = [9, 9]; 
  } 
  else if ((profundidad >= 180) && (magnitud >= 4.0 && magnitud < 5.0)) {
    iconUrl = "assets/img/pointsMap/puntomorado3.gif";
    iconSize = [11, 11]; 
  } 
  else if ((profundidad >= 180) && (magnitud >= 5.0 && magnitud < 6.0)) {
    iconUrl = "assets/img/pointsMap/puntomorado4.gif";
    iconSize = [15, 15]; 
  } else if ((profundidad >= 180) && (magnitud >= 6.0 && magnitud <= 9.0)) {
    iconUrl = "assets/img/pointsMap/puntomorado5.gif";
    iconSize = [26, 26]; 
  }

  return L.icon({
    iconUrl,
    iconSize, 
    iconAnchor: [iconSize[0] / 2, iconSize[1] / 2], 
    popupAnchor: [0, -iconSize[1] / 2],
    className: ""
  });
};

return (
  <MapContainer
    center={[4.6, -74.1]}
    zoom={6}
    style={{ height: '100vh', width: '100%' }}
  >
    <LayersControl position="topright">
      {/* Capa base 1 */}
      <BaseLayer checked name="Esri Topo Map">
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
          attribution="Tiles &copy; Esri &mdash; Source: USGS, Esri"
          maxZoom={20}
        />
      </BaseLayer>

      {/* Capa base 2 */}
      <BaseLayer name="OpenStreetMap">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
      </BaseLayer>

      {/* Capa base 3 */}
      <BaseLayer name="Esri Satellite">
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution="Tiles &copy; Esri"
        />
      </BaseLayer>

       {points.length > 0 &&
        points.map((point, idx) => (
          <Marker
            key={idx}
            position={[
              parseFloat(point.latitude),
              parseFloat(point.longitude)
            ]}
            icon={getCustomIcon(point.magnitude, point.depth)} // <-- ícono dinámico
          >
            <Popup>
                {point.name ? (
                    point.name
                ) : (
                    <>
                    Mag: {point.magnitude} {point.mag_type} <br />
                    Prof: {point.depth} Km <br />
                    Región: {point.region} <br />
                    Lat: {point.latitude}, Lon: {point.longitude}
                    </>
                )}
            </Popup>
          </Marker>
        ))}
    </LayersControl>

    <LegendWithImage />
  </MapContainer>
);
};

export default MapEarthquake;